module.exports = __webpack_public_path__ + "static/media/88 back screen-mobile.fae0611c.webp";